export default __webpack_public_path__ + "static/media/icons3.fea26baa.svg";